import { langFallback$Fetch } from '../../lang/utils/langfetch'
import { csrfTokenService } from '../csrf/CsrfTokenService'
import { PaymentCard, paymentCardSchema } from './schema'

interface ApiCard {
  brand: string
  exp_month: number | string
  exp_year: number | string
  id: number | string
  last4: string
  can_delete: boolean
}

interface StoredCardsResponse {
  cards: ApiCard[]
}

export class UserStoredCardsRepositoryFetch {
  async readAll(langCode: string): Promise<PaymentCard[]> {
    const results = await langFallback$Fetch<StoredCardsResponse>(
      langCode,
      '/_/users/stored-cards/',
    )
    return this.mappedCards(results.cards)
  }

  private mappedCards(cards: ApiCard[]): PaymentCard[] {
    return cards.map((card) => {
      return paymentCardSchema.parse({
        brand: card.brand,
        expMonth: card.exp_month.toString(),
        expYear: card.exp_year.toString(),
        id: card.id.toString(),
        last4: card.last4.toString(),
        canDelete: card.can_delete,
      })
    })
  }

  async delete(cardId: string, langCode: string): Promise<void> {
    const { csrfToken } = await csrfTokenService()
    await langFallback$Fetch(langCode, `/_/users/stored-cards/${cardId}/`, {
      method: 'DELETE',
      headers: {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- csrfToken from untyped service
        'X-CSRFToken': csrfToken,
      },
    })
  }
}
